import styled from 'styled-components';
import { GrowingInput } from './GrowingInput';
import { textColor, THEME_PRIMARY } from '../../styles/basics/colors';

export const StGrowingInput = styled(GrowingInput)`
    text-align: center;
    margin: 0 2px;
`;

export const StNumberSpinner = styled.div.attrs({ 'data-displayname': 'NumberSpinner' })<any>`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    pointer-events: ${props => (props.disabled ? 'none' : null)};
    cursor: ${props => (props.disabled ? 'default' : null)};
`;

export const StButton = styled.a`
    ${textColor(THEME_PRIMARY)} !important;
    font-size: 16px;
`;

export const StDisabledButton = styled.span`
    font-size: 16px;
`;
